import { LeadSourceDTO, LeadStatusDTO } from "@gymflow/types";
import { validatePhoneNumber } from "@gymflow/validation";
import z from "zod";

export const LeadFormSchema = z.object({
  firstName: z.string().min(1, "common.required"),
  lastName: z.string().min(1, "common.required"),
  mobileNumber: z
    .string()
    .trim()
    .min(1, "common.required")
    .refine((e) => !e || validatePhoneNumber(e), {
      message: `validation.phoneNumber`,
    }),
  leadStatus: z.object({
    id: z.number(),
    label: z.string(),
    value: z.custom<LeadStatusDTO>(),
  }),
  source: z.object({
    id: z.number(),
    label: z.string(),
    value: z.custom<LeadSourceDTO>(),
  }),
});
